import { SourgumFifteenYdDimensions2 } from '../components/icons/roll-off-dumpsters/fifteen-yard-dimensions-sourgum2';
import { SourgumFortyYdDimensions2 } from '../components/icons/roll-off-dumpsters/forty-yard-dimensions-sourgum2';
import { SourgumSixYdDimensions2 } from '../components/icons/roll-off-dumpsters/six-yard-dimensions-sourgum2';
import { SourgumTenYdDimensions2 } from '../components/icons/roll-off-dumpsters/ten-yard-dimensions-sourgum2';
import { SourgumThirtyYdDimensions2 } from '../components/icons/roll-off-dumpsters/thirty-yard-dimensions-sourgum2';
import { SourgumTwentyYdDimensions2 } from '../components/icons/roll-off-dumpsters/twenty-yard-dimensions-sourgum2';
export const informationForRolloffSizeSourgum = {
    '6': {
        pickups: '3',
        image: SourgumSixYdDimensions2,
    },
    '10': {
        pickups: '4',
        image: SourgumTenYdDimensions2,
    },
    '15': {
        pickups: '6',
        image: SourgumFifteenYdDimensions2,
    },
    '20': {
        pickups: '8',
        image: SourgumTwentyYdDimensions2,
    },
    '25': {
        pickups: '10',
        image: SourgumTwentyYdDimensions2,
    },
    '30': {
        pickups: '12',
        image: SourgumThirtyYdDimensions2,
    },
    '40': {
        pickups: '16',
        image: SourgumFortyYdDimensions2,
    },
};
//# sourceMappingURL=information-for-roll-off-size.js.map